import { create } from 'zustand';

import { withDevtools } from './middleware-utils';

// ============================================================================
// BREADCRUMB STORE
// ============================================================================

export interface BreadcrumbItem {
  label: string;
  href?: string;
  onClick?: () => void;
}

interface BreadcrumbState {
  items: BreadcrumbItem[];
  activeIndex: number;

  // Actions
  setItems: (items: BreadcrumbItem[]) => void;
  setActiveIndex: (index: number) => void;
  reset: () => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>()(
  withDevtools('Breadcrumb', set => ({
    items: [],
    activeIndex: 0,

    setItems: items => {
      set({ items, activeIndex: items.length - 1 });
    },

    setActiveIndex: activeIndex => {
      set({ activeIndex });
    },

    reset: () => {
      set({ items: [], activeIndex: 0 });
    },
  }))
);
